import { render } from "./TopApp.vue?vue&type=template&id=2105d9d3&scoped=true"
import script from "./TopApp.vue?vue&type=script&lang=js"
export * from "./TopApp.vue?vue&type=script&lang=js"

import "./TopApp.vue?vue&type=style&index=0&id=2105d9d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2105d9d3"]])

export default __exports__